var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlechaActivoPequea24X24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.807923 1.13968C1.06223 0.812716 1.53343 0.753815 1.86039 1.00812L4.99994 3.44999L8.13948 1.00812C8.46644 0.753815 8.93765 0.812716 9.19195 1.13968C9.44625 1.46664 9.38735 1.93784 9.06039 2.19215L5.46039 4.99215C5.18956 5.20279 4.81031 5.20279 4.53948 4.99215L0.939481 2.19215C0.612521 1.93784 0.55362 1.46664 0.807923 1.13968Z",
    fill: "#2AA288"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaActivoPequea24X24);
export default __webpack_public_path__ + "static/media/FLECHA-ACTIVO-PEQUEÑA_24X24.69fd78d4a02a031eb6ab1efc7587a87c.svg";
export { ForwardRef as ReactComponent };